import { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { ContentApi } from "../../../../shared/api/contentApi";
import { Form, App, Select } from "antd";
import { DETAIL_FIELD_CLASS } from "../../../../shared/constants/detailLayout";

const NO_PARENT_GROUP = "__none__";

export default function SelectParentGroup({
    open,
    projectId,
    versionId,
    value,
    onChange,
    fieldName = "parentGroupParameterId",
    label = "Родительский параметр",
    placeholder = "Выбрать родительскую группу...",
}) {
    const [parentGroups, setParentGroups] = useState([]);
    const [loadingParentGroups, setLoadingParentGroups] = useState(false);
    const [parentGroupsError, setParentGroupsError] = useState("");

    useEffect(() => {
        if (!open) return;
        setParentGroups([]);
        setParentGroupsError("");
        setLoadingParentGroups(false);
    }, [open]);


    useEffect(() => {
        if (!open || !projectId || !versionId) return;

        const ac = new AbortController();
        setLoadingParentGroups(true);
        setParentGroupsError("");

        ContentApi.getParameterGroups(
            {
                projectId,
                versionId,
                page: 1,
                pageSize: 1000,
            },
            { signal: ac.signal },
        )
            .then((data) => {
                if (ac.signal.aborted) return;
                setParentGroups(Array.isArray(data?.items) ? data.items : []);
            })
            .catch((e) => {
                if (ac.signal.aborted) return;
                setParentGroups([]);
                setParentGroupsError(e?.message || "Не удалось загрузить группы параметров");
            })
            .finally(() => {
                if (!ac.signal.aborted) setLoadingParentGroups(false);
            });

        return () => ac.abort();
    }, [open, projectId, versionId]);


    return (
        <App>
            <Form.Item label={label} className="flex flex-col mb-1">
                <Select
                    className={DETAIL_FIELD_CLASS}
                    value={value || NO_PARENT_GROUP}
                    onChange={(nextValue) => onChange(nextValue === NO_PARENT_GROUP ? null : nextValue)}
                    placeholder={placeholder}
                    disabled={loadingParentGroups}
                    options={[
                        { label: "Нет родительской группы", value: NO_PARENT_GROUP },
                        ...parentGroups
                            .map((group) => {
                                const groupId = group?.id || group?.groupParameterId;
                                if (!groupId) return null;
                                return {
                                    label: `${group.name || group.systemName} (${group.systemName})`,
                                    value: String(groupId),
                                };
                            })
                            .filter(Boolean),
                    ]}
                />
                {parentGroupsError && (
                    <div className="mt-1 text-sm text-red-600">{parentGroupsError}</div>
                )}
            </Form.Item>
        </App>
    );
}

SelectParentGroup.propTypes = {
    open: PropTypes.bool,
    projectId: PropTypes.string,
    versionId: PropTypes.string,
    value: PropTypes.string,
    onChange: PropTypes.func.isRequired,
    fieldName: PropTypes.string,
    label: PropTypes.string,
    placeholder: PropTypes.string,
};
